import React from 'react';

import './index.less';
import Icon from './../basic-icon'
export default () => (
    <div className="elevator">
        <a><Icon type="icon-arrow-up"></Icon></a>
        <a><Icon type="icon-suggest"></Icon></a>
        <a><Icon type="icon-atm-away"></Icon></a>
    </div>
)